import { render, staticRenderFns } from "./AdminCouponList.vue?vue&type=template&id=9c04a192"
import script from "./AdminCouponList.vue?vue&type=script&lang=js"
export * from "./AdminCouponList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports